(function () {
  function refresh(root) {
    (root || document).querySelectorAll('[data-designer-week-points]').forEach(function (node) {
      var amount = Number(node.dataset.amountMinor);
      var rate = Number(node.dataset.exchangeRate);
      var multiplier = Number(node.dataset.multiplier);
      if (!Number.isFinite(amount) || amount < 0 || !Number.isFinite(rate) || rate <= 0) return;
      var country = (node.dataset.countryCode || 'US').toUpperCase();
      var points = Math.round((amount / 100) * multiplier / (country === 'US' ? 1 : rate));
      var value = node.querySelector('.designer-week-points__value');
      if (value) value.textContent = String(points);
      node.dataset.points = String(points);
    });
  }

  function refreshCartPoints(totalElement) {
    var amount = Number(totalElement.dataset.cartTotalPrice);
    if (!Number.isFinite(amount) || amount < 0) return;

    var drawer = totalElement.closest('cart-drawer');
    var summaryColumn = totalElement.closest('.cart__summary-column');
    var scope = drawer || summaryColumn || document;
    var pointsNodes = scope.querySelectorAll(
      '[data-designer-week-points][data-context="cart"]'
    );

    pointsNodes.forEach(function (node) {
      node.dataset.amountMinor = String(amount);
    });
    refresh(scope);
  }

  function observeCartTotal() {
    if (!('MutationObserver' in window)) return;

    var refreshFrame;
    function scheduleCartPointsRefresh() {
      window.cancelAnimationFrame(refreshFrame);
      refreshFrame = window.requestAnimationFrame(function () {
        document.querySelectorAll('[data-cart-total-price]').forEach(
          refreshCartPoints
        );
      });
    }

    var observer = new MutationObserver(function (mutations) {
      var cartChanged = mutations.some(function (mutation) {
        return (
          (mutation.type === 'attributes' &&
            mutation.attributeName === 'data-cart-total-price') ||
          (mutation.type === 'childList' &&
            mutation.target.closest?.('cart-drawer, .cart__summary-column'))
        );
      });

      if (cartChanged) scheduleCartPointsRefresh();
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-cart-total-price'],
      childList: true,
      subtree: true,
    });
  }

  window.DesignerWeekPoints = { refresh: refresh };
  document.addEventListener('DOMContentLoaded', function () {
    refresh();
    document.querySelectorAll('[data-cart-total-price]').forEach(refreshCartPoints);
    observeCartTotal();
  });
  document.addEventListener('variant-change', function (event) {
    var variant = event.detail?.data?.variant || event.detail?.variant;
    if (!variant || variant.price == null) return;
    document.querySelectorAll('[data-designer-week-points][data-context="product"]').forEach(function (node) {
      node.dataset.amountMinor = String(variant.price);
    });
    refresh();
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event?.data?.variant;
      if (!variant || variant.price == null) return;
      document.querySelectorAll('[data-designer-week-points][data-context="product"]').forEach(function (node) {
        node.dataset.amountMinor = String(variant.price);
      });
      refresh();
    });
  }
})();
